import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[OnlyNumbers]'
})
export class OnlyNumbersDirective {
  @Input() OnlyNumbers: boolean;

  constructor(private el: ElementRef) {}

  @HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent): void {
    if (this.OnlyNumbers) {
      if (
        ['46', '8', '9', '27', '13', '110', '190'].indexOf(event.key) !== -1 ||
        // Allow: Ctrl+A
        (event.key === '65' && event.ctrlKey === true) ||
        // Allow: Ctrl+C
        (event.key === '67' && event.ctrlKey === true) ||
        // Allow: Ctrl+V
        (event.key === '86' && event.ctrlKey === true) ||
        // Allow: Ctrl+X
        (event.key === '88' && event.ctrlKey === true) ||
        // Allow: home, end, left, right
        (event.key >= '35' && event.key <= '39')
      ) {
        // let it happen, don't do anything
        return;
      }
      // Ensure that it is a number and stop the keypress
      if (
        (event.shiftKey || (event.key < '48' || event.key > '57')) &&
        (event.key < '96' || event.key > '105')
      ) {
        event.preventDefault();
      }
    }
  }
}
